window.addEventListener('load', () => {
  setTimeout(() => document.getElementById('loader').classList.add('gone'), 2500);
});

function buildTitle(){
  const lines = document.querySelectorAll('#caption1 h1 .line');
  lines.forEach((line, lineIdx) => {
    const text = line.dataset.text;
    const isItalic = line.dataset.italic === 'true';
    line.innerHTML = '';
    [...text].forEach((char, i) => {
      const span = document.createElement('span');
      span.className = 'char';
      span.textContent = char === ' ' ? '\u00A0' : char;
      if(isItalic){
        const em = document.createElement('em');
        em.style.fontStyle = 'italic';
        em.appendChild(span);
        line.appendChild(em);
      } else {
        line.appendChild(span);
      }
      span.style.animation = `rise 1.2s cubic-bezier(.23,1,.32,1) ${2.7 + lineIdx*0.18 + i*0.028}s forwards`;
    });
  });
}
buildTitle();

function tickTime(){
  const d = new Date();
  document.getElementById('liveTime').textContent =
    `${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
}
setInterval(tickTime, 1000); tickTime();

const cursor = document.getElementById('cursor');
const cursorLabel = document.getElementById('cursorLabel');
let mx=0, my=0, cx=0, cy=0;
document.addEventListener('mousemove', e => {
  mx = e.clientX; my = e.clientY;
  cursorLabel.style.left = mx+'px';
  cursorLabel.style.top = my+'px';
});
function loop(){
  cx += (mx-cx)*0.18; cy += (my-cy)*0.18;
  cursor.style.left=cx+'px'; cursor.style.top=cy+'px';
  requestAnimationFrame(loop);
}
loop();
document.querySelectorAll('a, .artifact, .bestseller-card, .collection-card').forEach(el=>{
  el.addEventListener('mouseenter', ()=>cursor.classList.add('big'));
  el.addEventListener('mouseleave', ()=>cursor.classList.remove('big'));
});

// ============ THREE.JS ============
const container = document.getElementById('canvas3d');
const scene = new THREE.Scene();
scene.fog = new THREE.FogExp2(0x0a0807, 0.03);

const camera = new THREE.PerspectiveCamera(55, window.innerWidth/window.innerHeight, 0.1, 200);
camera.position.set(0, 1.8, 10);

const renderer = new THREE.WebGLRenderer({antialias:true});
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.setClearColor(0x0a0807);
container.appendChild(renderer.domElement);

// MATERIALS
const marbleFloorMat = new THREE.MeshPhysicalMaterial({
  color: 0x1a1614, roughness: 0.15, metalness: 0.3,
  clearcoat: 0.8, clearcoatRoughness: 0.15
});
const stoneWallMat = new THREE.MeshStandardMaterial({color: 0x2a2623, roughness: 0.85, metalness: 0.1});
const stoneWallDarkMat = new THREE.MeshStandardMaterial({color: 0x1c1917, roughness: 0.88, metalness: 0.1});
const goldMat = new THREE.MeshPhysicalMaterial({
  color: 0xc8a562, roughness: 0.2, metalness: 0.9,
  clearcoat: 0.5, emissive: 0x8a6b35, emissiveIntensity: 0.15
});
const goldTrimMat = new THREE.MeshPhysicalMaterial({
  color: 0xc8a562, roughness: 0.25, metalness: 0.95,
  emissive: 0xc8a562, emissiveIntensity: 0.25
});
const darkWoodMat = new THREE.MeshStandardMaterial({color: 0x2a1f16, roughness: 0.6, metalness: 0.15});

// Continuous marble floor
const floor = new THREE.Mesh(new THREE.PlaneGeometry(30, 110), marbleFloorMat);
floor.rotation.x = -Math.PI/2;
floor.position.z = -30;
scene.add(floor);

// Gold inlay lines on floor
for(let z = 5; z > -100; z -= 8){
  const inlay = new THREE.Mesh(new THREE.BoxGeometry(20, 0.008, 0.04), goldTrimMat);
  inlay.position.set(0, 0.01, z);
  scene.add(inlay);
}

// ====== ROOM 1 : ENTRANCE HALL ======
const r1 = new THREE.Group();
scene.add(r1);

const r1back = new THREE.Mesh(new THREE.PlaneGeometry(30, 16), stoneWallMat);
r1back.position.set(0, 6, -10);
r1.add(r1back);
const r1right = new THREE.Mesh(new THREE.PlaneGeometry(20, 16), stoneWallMat);
r1right.rotation.y = -Math.PI/2;
r1right.position.set(10, 6, 0);
r1.add(r1right);
const r1left = new THREE.Mesh(new THREE.PlaneGeometry(20, 16), stoneWallMat);
r1left.rotation.y = Math.PI/2;
r1left.position.set(-10, 6, 0);
r1.add(r1left);
const r1ceil = new THREE.Mesh(new THREE.PlaneGeometry(30, 20), stoneWallDarkMat);
r1ceil.rotation.x = Math.PI/2;
r1ceil.position.set(0, 14, 0);
r1.add(r1ceil);

// Gold cornices
[[[0, 13.2, -9.95], [0, 0, 0], [30, 0.2, 0.1]],
 [[9.95, 13.2, 0], [0, Math.PI/2, 0], [20, 0.2, 0.1]],
 [[-9.95, 13.2, 0], [0, Math.PI/2, 0], [20, 0.2, 0.1]]].forEach(c => {
  const cornice = new THREE.Mesh(new THREE.BoxGeometry(...c[2]), goldTrimMat);
  cornice.position.set(...c[0]);
  cornice.rotation.set(...c[1]);
  r1.add(cornice);
});

// Gold baseboard
const bb1 = new THREE.Mesh(new THREE.BoxGeometry(30, 0.15, 0.08), goldTrimMat);
bb1.position.set(0, 0.075, -9.95);
r1.add(bb1);

// Alcoves on back wall
for(let i=0; i<2; i++){
  const xoff = i === 0 ? -6 : 6;
  const archFrame = new THREE.Mesh(
    new THREE.PlaneGeometry(3, 7),
    new THREE.MeshStandardMaterial({color: 0x100e0c, roughness: 0.7})
  );
  archFrame.position.set(xoff, 4.5, -9.9);
  r1.add(archFrame);
  [[xoff, 8, -9.88, 3.2, 0.08], [xoff, 1, -9.88, 3.2, 0.08]].forEach(bar => {
    const b = new THREE.Mesh(new THREE.BoxGeometry(bar[3], bar[4], 0.1), goldTrimMat);
    b.position.set(bar[0], bar[1], bar[2]);
    r1.add(b);
  });
  [[xoff-1.5, 4.5], [xoff+1.5, 4.5]].forEach(pos => {
    const b = new THREE.Mesh(new THREE.BoxGeometry(0.08, 7, 0.1), goldTrimMat);
    b.position.set(pos[0], pos[1], -9.88);
    r1.add(b);
  });
}

// Central pedestal
const pedestalTop = new THREE.Mesh(new THREE.CylinderGeometry(1.8, 1.9, 0.2, 64), marbleFloorMat);
pedestalTop.position.set(0, 0.9, 0);
r1.add(pedestalTop);
const pedestalMid = new THREE.Mesh(
  new THREE.CylinderGeometry(1.9, 1.7, 0.7, 64),
  new THREE.MeshStandardMaterial({color: 0x1a1614, roughness: 0.25, metalness: 0.4})
);
pedestalMid.position.set(0, 0.5, 0);
r1.add(pedestalMid);
const pedestalBottom = new THREE.Mesh(new THREE.CylinderGeometry(1.7, 2, 0.15, 64), marbleFloorMat);
pedestalBottom.position.set(0, 0.075, 0);
r1.add(pedestalBottom);
// Gold rings around pedestal
[[1.85, 0.85], [1.95, 0.15]].forEach(r => {
  const ring = new THREE.Mesh(new THREE.TorusGeometry(r[0], 0.03, 16, 64), goldTrimMat);
  ring.rotation.x = Math.PI/2;
  ring.position.set(0, r[1], 0);
  r1.add(ring);
});

// GOLD F·F LOGO
const logoGroup = new THREE.Group();
logoGroup.position.set(0, 2.5, 0);
r1.add(logoGroup);

function buildF(offsetX, thickness = 0.24){
  const fGroup = new THREE.Group();
  const vert = new THREE.Mesh(new THREE.BoxGeometry(thickness, 2.2, thickness), goldMat);
  vert.position.set(-0.55 + offsetX, 0, 0);
  fGroup.add(vert);
  const topBar = new THREE.Mesh(new THREE.BoxGeometry(1.1, thickness, thickness), goldMat);
  topBar.position.set(0 + offsetX, 1.1 - thickness/2, 0);
  fGroup.add(topBar);
  const midBar = new THREE.Mesh(new THREE.BoxGeometry(0.82, thickness, thickness), goldMat);
  midBar.position.set(-0.14 + offsetX, 0.12, 0);
  fGroup.add(midBar);
  return fGroup;
}

logoGroup.add(buildF(-1.3));
const dot3d = new THREE.Mesh(new THREE.SphereGeometry(0.18, 32, 32), goldMat);
dot3d.position.set(0, -0.45, 0);
logoGroup.add(dot3d);
logoGroup.add(buildF(1.3));

const logoRing1 = new THREE.Mesh(new THREE.TorusGeometry(2.8, 0.025, 16, 100), goldTrimMat);
logoRing1.rotation.x = Math.PI/3;
logoGroup.add(logoRing1);

const logoRing2 = new THREE.Mesh(
  new THREE.TorusGeometry(3.1, 0.02, 16, 100),
  new THREE.MeshPhysicalMaterial({
    color: 0xc8a562, roughness: 0.3, metalness: 0.9,
    emissive: 0xc8a562, emissiveIntensity: 0.1,
    transparent: true, opacity: 0.5
  })
);
logoRing2.rotation.x = Math.PI/2.3;
logoRing2.rotation.z = 0.3;
logoGroup.add(logoRing2);

// Chandelier
const chandelier = new THREE.Group();
chandelier.position.set(0, 13.5, 0);
r1.add(chandelier);

const chandBase = new THREE.Mesh(new THREE.CylinderGeometry(0.1, 0.1, 0.3, 8), darkWoodMat);
chandelier.add(chandBase);

const chandRing = new THREE.Mesh(new THREE.TorusGeometry(0.8, 0.04, 16, 32), goldTrimMat);
chandRing.position.y = -0.5;
chandelier.add(chandRing);

for(let i=0; i<8; i++){
  const angle = (i/8) * Math.PI*2;
  const ball = new THREE.Mesh(
    new THREE.SphereGeometry(0.05, 16, 16),
    new THREE.MeshBasicMaterial({color: 0xe8c87a})
  );
  ball.position.set(Math.cos(angle)*0.8, -0.5, Math.sin(angle)*0.8);
  chandelier.add(ball);
}

// ====== ROOM 2 : LE CABINET ======
const r2 = new THREE.Group();
r2.position.z = -35;
scene.add(r2);

const r2back = new THREE.Mesh(new THREE.PlaneGeometry(30, 16), stoneWallMat);
r2back.position.set(0, 6, -10);
r2.add(r2back);
const r2left = new THREE.Mesh(new THREE.PlaneGeometry(20, 16), stoneWallMat);
r2left.rotation.y = Math.PI/2;
r2left.position.set(-10, 6, 0);
r2.add(r2left);
const r2right = new THREE.Mesh(new THREE.PlaneGeometry(20, 16), stoneWallMat);
r2right.rotation.y = -Math.PI/2;
r2right.position.set(10, 6, 0);
r2.add(r2right);
const r2ceil = new THREE.Mesh(new THREE.PlaneGeometry(30, 20), stoneWallDarkMat);
r2ceil.rotation.x = Math.PI/2;
r2ceil.position.set(0, 14, 0);
r2.add(r2ceil);

// Gold cornices for r2
[[[0, 13.2, -9.95], [0, 0, 0], [30, 0.2, 0.1]],
 [[9.95, 13.2, 0], [0, Math.PI/2, 0], [20, 0.2, 0.1]],
 [[-9.95, 13.2, 0], [0, Math.PI/2, 0], [20, 0.2, 0.1]]].forEach(c => {
  const cornice = new THREE.Mesh(new THREE.BoxGeometry(...c[2]), goldTrimMat);
  cornice.position.set(...c[0]);
  cornice.rotation.set(...c[1]);
  r2.add(cornice);
});
const bb2 = new THREE.Mesh(new THREE.BoxGeometry(30, 0.15, 0.08), goldTrimMat);
bb2.position.set(0, 0.075, -9.95);
r2.add(bb2);

// Marble columns with gold capitals
[[-6, -3], [6, -3], [-6, 3], [6, 3]].forEach(c => {
  const shaft = new THREE.Mesh(
    new THREE.CylinderGeometry(0.35, 0.35, 12, 16),
    new THREE.MeshPhysicalMaterial({color: 0x1c1917, roughness: 0.2, metalness: 0.35, clearcoat: 0.5})
  );
  shaft.position.set(c[0], 6, c[1]);
  r2.add(shaft);

  const capital = new THREE.Mesh(new THREE.CylinderGeometry(0.5, 0.35, 0.4, 16), goldTrimMat);
  capital.position.set(c[0], 12.2, c[1]);
  r2.add(capital);

  const colBase = new THREE.Mesh(new THREE.CylinderGeometry(0.45, 0.55, 0.3, 16), goldTrimMat);
  colBase.position.set(c[0], 0.15, c[1]);
  r2.add(colBase);
});

// 4 gold spot fixtures
[[-4.5, -2], [-1.5, -3], [1.5, -3], [4.5, -2]].forEach(p => {
  const chain = new THREE.Mesh(new THREE.CylinderGeometry(0.015, 0.015, 0.8, 8), goldTrimMat);
  chain.position.set(p[0], 13.5, p[1]);
  r2.add(chain);

  const fixture = new THREE.Mesh(new THREE.CylinderGeometry(0.18, 0.28, 0.4, 16), goldMat);
  fixture.position.set(p[0], 12.9, p[1]);
  r2.add(fixture);

  const cone = new THREE.Mesh(
    new THREE.ConeGeometry(2.5, 10, 32, 1, true),
    new THREE.MeshBasicMaterial({color: 0xc8a562, transparent: true, opacity: 0.06, side: THREE.DoubleSide})
  );
  cone.position.set(p[0], 7.5, p[1]);
  r2.add(cone);
});

// Gold ring on floor at r2 center
const floorRingR2 = new THREE.Mesh(new THREE.RingGeometry(2.5, 2.55, 64), goldTrimMat);
floorRingR2.rotation.x = -Math.PI/2;
floorRingR2.position.set(0, 0.015, 0);
r2.add(floorRingR2);

// ====== ROOM 3 : LES ARCHIVES ======
const r3 = new THREE.Group();
r3.position.z = -62;
scene.add(r3);

const r3back = new THREE.Mesh(new THREE.PlaneGeometry(30, 16), stoneWallDarkMat);
r3back.position.set(0, 6, -10);
r3.add(r3back);
const r3left = new THREE.Mesh(new THREE.PlaneGeometry(20, 16), stoneWallMat);
r3left.rotation.y = Math.PI/2;
r3left.position.set(-10, 6, 0);
r3.add(r3left);
const r3right = new THREE.Mesh(new THREE.PlaneGeometry(20, 16), stoneWallMat);
r3right.rotation.y = -Math.PI/2;
r3right.position.set(10, 6, 0);
r3.add(r3right);
const r3ceil = new THREE.Mesh(new THREE.PlaneGeometry(30, 20), stoneWallDarkMat);
r3ceil.rotation.x = Math.PI/2;
r3ceil.position.set(0, 14, 0);
r3.add(r3ceil);

// Cornices
[[[0, 13.2, -9.95], [0, 0, 0], [30, 0.2, 0.1]],
 [[9.95, 13.2, 0], [0, Math.PI/2, 0], [20, 0.2, 0.1]],
 [[-9.95, 13.2, 0], [0, Math.PI/2, 0], [20, 0.2, 0.1]]].forEach(c => {
  const cornice = new THREE.Mesh(new THREE.BoxGeometry(...c[2]), goldTrimMat);
  cornice.position.set(...c[0]);
  cornice.rotation.set(...c[1]);
  r3.add(cornice);
});

// 3 framed panels on back wall
for(let i=0; i<3; i++){
  const xoff = -5 + i*5;
  const frame = new THREE.Mesh(
    new THREE.PlaneGeometry(3.5, 7),
    new THREE.MeshStandardMaterial({color: 0x0f0c0a, roughness: 0.8})
  );
  frame.position.set(xoff, 5, -9.9);
  r3.add(frame);
  [[xoff, 8.5, -9.87, 3.7, 0.08], [xoff, 1.5, -9.87, 3.7, 0.08]].forEach(bar => {
    const b = new THREE.Mesh(new THREE.BoxGeometry(bar[3], bar[4], 0.1), goldTrimMat);
    b.position.set(bar[0], bar[1], bar[2]);
    r3.add(b);
  });
  [[xoff-1.75, 5], [xoff+1.75, 5]].forEach(pos => {
    const b = new THREE.Mesh(new THREE.BoxGeometry(0.08, 7, 0.1), goldTrimMat);
    b.position.set(pos[0], pos[1], -9.87);
    r3.add(b);
  });
}

// 3 gold fixtures for collections
[[-5, -3], [0, -3], [5, -3]].forEach(p => {
  const chain = new THREE.Mesh(new THREE.CylinderGeometry(0.015, 0.015, 0.8, 8), goldTrimMat);
  chain.position.set(p[0], 13.5, p[1]);
  r3.add(chain);

  const fixture = new THREE.Mesh(new THREE.CylinderGeometry(0.18, 0.28, 0.4, 16), goldMat);
  fixture.position.set(p[0], 12.9, p[1]);
  r3.add(fixture);

  const cone = new THREE.Mesh(
    new THREE.ConeGeometry(2.8, 10, 32, 1, true),
    new THREE.MeshBasicMaterial({color: 0xc8a562, transparent: true, opacity: 0.06, side: THREE.DoubleSide})
  );
  cone.position.set(p[0], 7.5, p[1]);
  r3.add(cone);
});

// LIGHTS — warm tungsten gold
scene.add(new THREE.AmbientLight(0xffe0b0, 0.18));

// Room 1
const l1chand = new THREE.PointLight(0xffb97a, 2.5, 20);
l1chand.position.set(0, 12.5, 0);
scene.add(l1chand);
const l1logoSpot = new THREE.SpotLight(0xffd9a3, 4, 10, Math.PI/5, 0.4, 1);
l1logoSpot.position.set(0, 10, 2);
l1logoSpot.target = logoGroup;
scene.add(l1logoSpot);
const l1fill = new THREE.PointLight(0xffc080, 1.5, 15);
l1fill.position.set(3, 4, 4);
scene.add(l1fill);
const l1back = new THREE.PointLight(0xc8a562, 0.8, 18);
l1back.position.set(0, 5, -6);
scene.add(l1back);

// Room 2
const l2a = new THREE.PointLight(0xffb97a, 2, 25);
l2a.position.set(0, 11, -35);
scene.add(l2a);
const l2b = new THREE.PointLight(0xffd9a3, 1.2, 18);
l2b.position.set(0, 7, -35);
scene.add(l2b);
const l2c = new THREE.PointLight(0xc8a562, 1, 20);
l2c.position.set(-5, 10, -35);
scene.add(l2c);
const l2d = new THREE.PointLight(0xc8a562, 1, 20);
l2d.position.set(5, 10, -35);
scene.add(l2d);

// Room 3
const l3a = new THREE.PointLight(0xffb97a, 1.8, 22);
l3a.position.set(0, 10, -62);
scene.add(l3a);
const l3b = new THREE.PointLight(0xffd9a3, 1, 18);
l3b.position.set(-5, 8, -62);
scene.add(l3b);
const l3c = new THREE.PointLight(0xffd9a3, 1, 18);
l3c.position.set(5, 8, -62);
scene.add(l3c);
const l3d = new THREE.PointLight(0xc8a562, 0.8, 15);
l3d.position.set(0, 5, -66);
scene.add(l3d);

// MOUSE
let mouseX = 0, mouseY = 0, tMouseX = 0, tMouseY = 0;
window.addEventListener('mousemove', e => {
  mouseX = (e.clientX/window.innerWidth - 0.5) * 2;
  mouseY = (e.clientY/window.innerHeight - 0.5) * 2;
});

// CAMERA PATH
function updateCameraFromScroll() {
  const scrollY = window.scrollY;
  const winH = window.innerHeight;
  const tourScroll = winH * 3;
  const t = Math.min(scrollY / tourScroll, 1);

  const keys = [
    {t: 0,    pos: [0, 2, 11],   look: [0, 2.5, 0]},
    {t: 0.14, pos: [0, 2, 4],    look: [0, 2.5, 0]},
    {t: 0.28, pos: [0, 2.5, -8], look: [0, 2.8, -20]},
    {t: 0.42, pos: [0, 2.8, -28], look: [0, 3.5, -38]},
    {t: 0.6,  pos: [0, 2.5, -36], look: [0, 3, -40]},
    {t: 0.78, pos: [0, 2.8, -54], look: [0, 3.3, -64]},
    {t: 1.0,  pos: [0, 3.3, -60], look: [0, 3.5, -68]}
  ];

  let k1 = keys[0], k2 = keys[1];
  for(let i=0; i<keys.length-1; i++){
    if(t >= keys[i].t && t <= keys[i+1].t){
      k1 = keys[i]; k2 = keys[i+1]; break;
    }
  }
  if(t >= keys[keys.length-1].t) k1 = k2 = keys[keys.length-1];

  const localT = k1 === k2 ? 0 : (t - k1.t) / (k2.t - k1.t);
  const eased = localT < 0.5 ? 2*localT*localT : 1 - Math.pow(-2*localT + 2, 2)/2;

  const px = k1.pos[0] + (k2.pos[0] - k1.pos[0]) * eased;
  const py = k1.pos[1] + (k2.pos[1] - k1.pos[1]) * eased;
  const pz = k1.pos[2] + (k2.pos[2] - k1.pos[2]) * eased;
  const lx = k1.look[0] + (k2.look[0] - k1.look[0]) * eased;
  const ly = k1.look[1] + (k2.look[1] - k1.look[1]) * eased;
  const lz = k1.look[2] + (k2.look[2] - k1.look[2]) * eased;

  tMouseX += (mouseX - tMouseX) * 0.04;
  tMouseY += (mouseY - tMouseY) * 0.04;

  camera.position.set(px + tMouseX*0.3, py - tMouseY*0.2, pz);
  camera.lookAt(lx, ly, lz);

  let currentRoom = 1, currentName = "I · L'Entrée";
  if(t > 0.28){ currentRoom = 2; currentName = 'II · Le Cabinet'; }
  if(t > 0.65){ currentRoom = 3; currentName = 'III · Les Archives'; }
  if(t >= 0.97){ currentRoom = 4; currentName = 'IV · La Bibliothèque'; }
  document.querySelectorAll('.room-dot').forEach((d, i) => {
    d.classList.toggle('active', i+1 === currentRoom);
  });
  document.getElementById('roomName').textContent = currentName;

  document.getElementById('caption1').classList.toggle('visible', t < 0.2);
  document.getElementById('caption2').classList.toggle('visible', t >= 0.35 && t < 0.6);
  document.getElementById('caption3').classList.toggle('visible', t >= 0.7 && t < 0.97);
  document.getElementById('bestsellerRow').classList.toggle('visible', t >= 0.38 && t < 0.62);
  document.getElementById('collectionRow').classList.toggle('visible', t >= 0.72 && t < 0.97);

  const heroCta = document.getElementById('heroScrollCta');
  if(t > 0.03) heroCta.classList.add('hide');
  else heroCta.classList.remove('hide');

  const sp = document.getElementById('scrollPersistent');
  if(t >= 0.97) sp.style.opacity = '0';
  else sp.style.opacity = '';

  document.getElementById('shopReveal').classList.toggle('visible', t >= 0.97);
}
window.addEventListener('scroll', updateCameraFromScroll);
updateCameraFromScroll();

// ANIMATE
const clock = new THREE.Clock();
function animate(){
  const time = clock.getElapsedTime();
  logoGroup.rotation.y = time * 0.2;
  logoGroup.position.y = 2.5 + Math.sin(time*0.5) * 0.08;
  logoRing1.rotation.z = time * 0.4;
  logoRing2.rotation.y = -time * 0.3;
  chandelier.rotation.y = Math.sin(time*0.3) * 0.05;
  renderer.render(scene, camera);
  requestAnimationFrame(animate);
}
animate();

window.addEventListener('resize', () => {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
});